import Alert from '@mui/material/Alert';
import { utils } from 'ethers';
import React, { useState, useEffect, useContext } from 'react';
import { observer } from 'mobx-react';
import { useAccount } from 'wagmi';
import { ServicesContext } from '../../../context-providers/ServicesProvider';
import { tokenDecimals } from '../../../helpers/config/contracts.config';
import { hardcodedErrorCodes } from '../../../helpers/error-message.helper';
import AmountInput from '../../AmountInput/AmountInput';
import NereusButton from '../../NereusButton/NereusButton';
import StatusIcon from '../../StatusIcon/StatusIcon';
import ModalWrapper from '../ModalWrapper/ModalWrapper';
import {earnBalanceStore} from "../../../stores/EarnBalanceStore";

import './NXUSD_USDC_LP_WithdrawDialog.scss';
import {ContractContext} from "../../../context-providers/ContractsProvider";

const buttonTexts = {
    withdraw: 'Confirm Unstake',
    withdrawing: 'Unstaking NXUSD-USDC LP',
    enterAmount: 'Enter Amount',
    insufficientFunds: 'Insufficient Funds'
};

const NXUSD_USDC_LP_WithdrawDialog: React.FC = observer(() => {
    const { address } = useAccount();
    const [amount, setAmount] = useState<string>('0');
    const [isPending, setIsPending] = useState<boolean>(false);
    const { depositWithdrawalEarnService } = useContext(ServicesContext);
    const { nrsContract, lpNxusdUsdcContract, lpNxusdUsdcStakingContract } = useContext(ContractContext);

    let error = null
    if (amount && Number(amount) > Number(earnBalanceStore.lpNxusdUsdcStakingBalanceDecimal)) {
        error = hardcodedErrorCodes.FE_NOT_ENOUGH_WITHDRAWABLE_BALANCE;
    }

    const btnDisabled = !Number(amount) || !!error

    let buttonText = buttonTexts.withdraw
    if (!amount || Number(amount) === 0) {
        buttonText = buttonTexts.enterAmount
    } else if (error === hardcodedErrorCodes.FE_NOT_ENOUGH_WITHDRAWABLE_BALANCE) {
        buttonText = buttonTexts.insufficientFunds;
    }
    if (isPending) {
        buttonText = buttonTexts.withdrawing
    }

    useEffect(() => {
        if (address && lpNxusdUsdcStakingContract) {
            earnBalanceStore.fetchNxusdUsdcStakingBalance(lpNxusdUsdcStakingContract, address);
        }
    }, [address]);

    const handleWithdraw = async () => {
        if (!amount) {
            return;
        }

        setIsPending(true);
        try {
            await depositWithdrawalEarnService.withdrawNXUSD_USDC_LP(utils.parseUnits(amount, tokenDecimals.lp));
            if (address) {
                earnBalanceStore.fetchBalancesNXUSD_USDC(nrsContract, lpNxusdUsdcContract, lpNxusdUsdcStakingContract, address)
            }
        } catch {}
        setIsPending(false);
    }

    return (
        <ModalWrapper className="WithdrawDialog"
                      headerChildren={<h2 className="nereus-body-m">Withdraw</h2>}
                      bodyChildren={<div className="WithdrawDialog__body">
                          <AmountInput label="Amount" asset="NXUSD-USDC LP"
                                       hasMaxButton={true}
                                       value={amount}
                                       available={earnBalanceStore.lpNxusdUsdcStakingBalanceDecimal}
                                       precision={18}
                                       onChange={amount => setAmount(amount === '' ? '0' : amount + '')}/>
                          {error &&
                              <Alert className="WithdrawDialog__error mt-4" variant="standard" severity="error">
                                  <span className="nereus-caption">{error}</span>
                              </Alert>}
                          <div className="flex pb-4 mt-4">
                              <NereusButton disabled={btnDisabled || isPending} variant="contained"
                                            onClick={handleWithdraw}
                                            className="bg-light-green text-dark-blue w-full">
                                  {buttonText} {isPending && <StatusIcon className="ml-1 inline" status="disabled-pending" />}
                              </NereusButton>
                          </div>
                      </div>}
        />
    );
});

export default NXUSD_USDC_LP_WithdrawDialog;
